<script>
    import { navigate } from "svelte-routing";
    import Analytics from "../components/Analytics.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import OrderList from "../components/OrderList.svelte";
    import Sidebar from "../components/Sidebar.svelte";
    import Topbar from "../components/Topbar.svelte";
    import Unimportant from "../components/Unimportant.svelte";

    let username = localStorage.getItem("username");
    let email = localStorage.getItem("email");
    let profile = localStorage.getItem("profile");
    function logout() {
        localStorage.clear("username");
        localStorage.clear("email");
        localStorage.clear("token");
        localStorage.clear("profile");

        navigate("/");
    }
</script>

<svelte:head>
    <!-- Le CSS
            ================================================== -->
    <link
        rel="stylesheet"
        href="https://bootadmin.org/style/vendor/library.min.css"
    />
    <link
        rel="stylesheet"
        href="https://bootadmin.org/style/vendor/jqueryui-flat/jquery-ui.min.css"
    />
    <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
        integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ"
        crossorigin="anonymous"
    />

    <link
        rel="stylesheet"
        href="https://bootadmin.org/style/core/style.min.css"
    />

    <!-- Le IE Conditionals
            ================================================== -->
    <!--[if lt IE 9]><script src="http://html5shim.googlecode.com/svn/trunk/html5.js"></script><![endif]-->

    <!-- Le Javascript Pre-loads
            ================================================== -->
    <script
        src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js">
    </script>
    <!-- Le Javascript -->
    <script
        src="https://code.jquery.com/ui/1.12.0/jquery-ui.min.js"
        integrity="sha256-eGE6blurk5sHj+rmkfsGYeKyZx3M4bG+ZlFyA7Kns7E="
        crossorigin="anonymous">
    </script>
    <script
        src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js"
        integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q"
        crossorigin="anonymous">
    </script>
    <script src="https://bootadmin.org/scripts/vendor/bootstrap.min.js">
    </script>
    <script src="https://bootadmin.org/scripts/vendor/library.min.js">
    </script>
    <script src="https://bootadmin.org/scripts/core/main.js">
    </script>
</svelte:head>
<div class="sidebar-open">
    <div class="page-container animation">
        <div id="dashboardPage">
            <Topbar />
            <Sidebar />
            <main>
                <slot></slot>
            </main>
        </div>
    </div>
</div>
